<template>
    <zen-one
        :showuserinfo="false"
        :crumbs="crumbs"
        title="Sistem Hasil Bersepadu Kedah (iHasil)"
    >
        <z-page title="Butiran : Pelanggan">
            <!-- <div class="message-box">
                <w-transition-fade>
                    <w-alert
                        class="my0 text-light"
                        v-if="form.submitted"
                        success
                        no-border
                    >
                        The form is valid, ready to send it!
                    </w-alert>

                    <w-alert
                        class="my0 text-light"
                        v-else-if="form.valid === false"
                        error
                        no-border
                    >
                        Terdapat {{ form.errorsCount }} ralat di dalam borang
                        ini.
                    </w-alert>
                </w-transition-fade>
            </div> -->

            <!-- <w-form
                class=""
                v-model="form.valid"
                v-model:errors-count="form.errorsCount"
                @validate="submitProfil"
                @success="onSuccess"
                v-if="form.no_id"
            > -->

            <w-form
                class=""
                v-model="form.valid"
                v-model:errors-count="form.errorsCount"
                @validate="submitProfil"
                @success="onSuccess"
                v-if="form.id"
            >
                <w-flex justify-left align-left class="mt3">
                    <!-- <div class="xs6 mr3">
                        <td class="fw-semibold m0" style="font-size: 11px">
                            Kategori Profil
                        </td>
                        <tr>
                            {{
                                form.kategori == 1 ? "INDIVIDU" : "SYARIKAT"
                            }}
                        </tr>
                    </div> -->

                    <div class="xs6 mr3">
                        <z-lookup
                            label="Kategori Profil *"
                            :options="kategori"
                            v-model="form.kategori"
                            placeholder="Sila Pilih Kategori Profil"
                            :sort="false"
                            :cache="false"
                            :validators="[validators.required]"
                        /><br />
                    </div>

                    <!-- <div class="xs6 mr3">
                        <td class="fw-semibold m0" style="font-size: 11px">
                            Jenis Pengenalan Diri
                        </td>
                        <tr>
                            {{
                                form.pengenalan_keterangan
                            }}
                        </tr>
                    </div> -->

                    <div class="xs6 mr3">
                        <z-lookup
                            label="Jenis Pengenalan Diri *"
                            name="lkp_pengenalan_id"
                            placeholder="Sila Pilih Jenis Pengenalan Diri"
                            :url="service_kutipan + 'lookup/pengenalan'"
                            :sort="false"
                            :cache="false"
                            v-model="form.lkp_pengenalan_id"
                            :validators="[validators.required]"
                        /><br />
                    </div>
                </w-flex>

                <w-flex justify-left align-left class="mt4">
                    <!-- <div class="xs6">
                        <td class="fw-semibold m0" style="font-size: 11px">
                            No. ID ( No Kad Pengenalan / No Tentera / No Daftar
                            Syarikat )
                        </td>
                        <tr>
                            {{
                                form.no_id
                            }}
                        </tr>
                    </div> -->

                    <div class="xs6">
                        <z-input
                            label="No. ID ( No Kad Pengenalan / No Tentera / No Daftar Syarikat )"
                            v-model="form.no_id"
                            name="no_id"
                            readonly
                            :validators="[validators.required]"
                        />
                    </div>

                    <div class="xs6">
                        <z-input
                            label="Nama"
                            v-model="form.nama"
                            name="nama"
                            :validators="[validators.required]"
                        />
                    </div>
                </w-flex>

                <!-- <w-flex justify-right align-right class="mt7">
                    <div class="xs2">
                        <td class="fw-semibold m0" style="font-size: 11px">
                            Jenis Alamat *
                        </td>
                    </div>

                    <template v-for="(dt, index) in lkp_jenis_alamat">
                        <w-radio
                            class="mr4"
                            v-model="form.lkp_jenis_alamat_id"
                            :return-value="dt.value"
                        >
                            {{ dt.label }}
                        </w-radio>
                    </template>
                </w-flex> -->

                <div class="xs10">
                    <w-flex justify-center align-center class="mt7">
                        <z-input
                            label="Alamat Surat Menyurat"
                            v-model="form.alamat1"
                            name="alamat1"
                            :validators="[validators.required]"
                        />
                    </w-flex>

                    <w-flex justify-center align-center class="mt7">
                        <z-input
                            label=""
                            v-model="form.alamat2"
                            name="alamat2"
                        />
                    </w-flex>

                    <w-flex justify-center align-center class="mt7">
                        <z-input
                            label=""
                            v-model="form.alamat3"
                            name="alamat3"
                        />
                    </w-flex>
                </div>

                <w-flex justify-left align-left class="mt5">
                    <div class="xs4 mr3">
                        <z-lookup
                            label="Poskod"
                            name="poskod"
                            placeholder="Sila Pilih Poskod"
                            :url="service_kutipan + 'lookup/lkp_poskod'"
                            :sort="false"
                            :cache="false"
                            v-model="form.lkp_poskod_id"
                        /><br />
                    </div>

                    <div class="xs4 mr3">
                        <td class="fw-semibold m0" style="font-size: 11px">
                            Bandar &nbsp;&nbsp;&nbsp;
                        </td>
                        <tr>
                            {{
                                form.bandar
                            }}
                        </tr>
                    </div>
                    <div class="xs4">
                        <td class="fw-semibold m0" style="font-size: 11px">
                            Negeri &nbsp;&nbsp;&nbsp;
                        </td>
                        <tr>
                            {{
                                form.negeri
                            }}
                        </tr>
                    </div>
                </w-flex>

                <w-flex justify-center align-center class="mt4">
                    <div class="xs6 mr3">
                        <z-input
                            label="No. Telefon"
                            v-model="form.no_tel"
                            name="no_tel"
                            type="tel"
                            
                        />
                    </div>
                    <div class="xs6">
                        <z-input
                            label="Emel"
                            type="email"
                            v-model="form.emel"
                            name="emel"
                        />
                    </div>
                </w-flex>

                <w-flex class="mt3" wrap align-center justify-end>
                    <div class="spacer" />
                    <w-button
                        class="my1"
                        bg-color="warning"
                        dark
                        @click="back()"
                        >Kembali</w-button
                    >
                    &nbsp;
                    <template v-if="$zutil.can('Pelanggan Kemaskini')">
                        <w-button
                            class="my1"
                            type="submit"
                            :disabled="form.valid === false"
                            :loading="form.submitted && !form.sent"
                        >
                            <w-icon dark tile class="mr2">fal fa-save</w-icon>
                            Hantar
                        </w-button>
                    </template>
                </w-flex>
            </w-form>
        </z-page>
    </zen-one>
</template>

<script>
import { reactive } from "vue";
import ZResource from "@/Modules/z-resource-service";

export default {
    extends: ZResource,
    components: {},
    props: {
        items: [Array, Object],
        id: [Array, Object, String],
    },
    data() {
        return {
            resourceurl: this.service_kutipan + "profil",
            reload: true,
            dialog: {
                show2: false,
                fullscreen: false,
                persistent: false,
                persistentNoAnimation: false,
                width: 500,
            },
            form: {
                valid: null,
                submitted: false,
                sent: false,
                errorsCount: 0,
                no_tel: "",
            },
            validators: {
                required: (value) => !!value || "Medan Ini Wajib Isi",
                consent: (value) => !!value || "You must agree",
                email: (value) =>
                    !!value.match(/\w+\.?\w+@\w+(\.\w+)+/i) ||
                    "Sila Semak Format Email",
                numeric: (value) => !isNaN(value) || "Medan Ini Wajib Numeric",
            },
            data: {
                permissions: [],
                roles: [],
            },
            form_profil: {},
            form_cari: {},
            // lkp_jenis_alamat: [],
            crumbs: [
                { label: "iHasil", route: "/" },
                { label: "Kutipan", route: "/kutipan" },
                { label: "Pelanggan", route: "/kutipan/pelanggan" },
                { label: "Kemas Kini", route: "/kutipan/pelanggan" },
            ],

            kategori: [
                {
                    value: 1,
                    label: "INDIVIDU",
                },
                {
                    value: 2,
                    label: "SYARIKAT",
                },
            ],
        };
    },
    methods: {
        onSuccess() {
            setTimeout(() => (this.form.sent = true), 2000);
            this.$inertia.visit(window.route("kutipan.pelanggan.index"));
        },
        onValidate() {
            this.form.sent = false;
            this.form.submitted = this.form.errorsCount === 0;
        },
        poskodDetail() {
            this.$zcomm
                .get(
                    this.service_kutipan +
                        "lookup/lkp_poskod_detail/" +
                        this.form.lkp_poskod_id
                )
                .then((res) => {
                    this.form.negeri = res.negeri;
                    this.form.lkp_negeri_id = res.lkp_negeri_id;
                    this.form.bandar = res.bandar;
                    this.form.lkp_jenis_alamat_id = 1;
                    // this.form.lkp_jenis_alamat_id = res.lkp_jenis_alamat_id;
                });
        },

        profilDetail() {
            this.$zcomm
                .get(this.service_kutipan + "profil/" + this.form_cari.id)
                .then((res) => {
                    this.form.profil_id = res.id;
                    this.form.kategori = res.kategori;
                    this.form.lkp_pengenalan_id = res.lkp_pengenalan_id;
                    // this.form.lkp_jenis_alamat_id = res.lkp_jenis_alamat_id;
                    this.form.no_id = res.no_id;
                    this.form.nama = res.nama;
                    this.form.alamat1 = res.alamat1;
                    this.form.alamat2 = res.alamat2;
                    this.form.alamat3 = res.alamat3;
                    this.form.poskod = res.poskod;
                    this.form.bandar = res.bandar;
                    this.form.negeri = res.negeri;
                });
        },
        jenisAlamat() {
            this.$zcomm
                .get(this.service_kutipan + "lookup/jenis_alamat")
                .then((res) => {
                    this.lkp_jenis_alamat = res;
                })
                .catch((err) => {})
                .finally(() => {});
        },
        submitProfil() {
            // if (this.$refs.form.validate()) {
            this.dialog.loading = true;

            this.$zcomm
                .post(this.service_kutipan + "profil", this.form)
                .then((res) => {
                    // console.log(res)
                    //update displayed record
                    // this.$page.flash.success = "Rekod telah ditambah"
                    this.mapreturneddata(res);
                    this.dialog.show = false;
                    if (typeof this.onAfterAdd === "function") {
                        this.onAfterAdd();
                    }
                    this.form.profil_id = res.id;
                    this.form.kategori = res.kategori;
                    this.form.lkp_pengenalan_id = res.lkp_pengenalan_id;
                    // this.form.lkp_jenis_alamat_id = res.lkp_jenis_alamat_id;
                    this.form.no_id = res.no_id;
                    this.form.nama = res.nama;
                    this.form.lkp_jenis_alamat = res.lkp_jenis_alamat;
                    this.form.alamat1 = res.alamat1;
                    this.form.alamat2 = res.alamat2;
                    this.form.alamat3 = res.alamat3;
                    this.form.poskod = res.poskod;
                    this.form.bandar = res.bandar;
                    this.form.negeri = res.negeri;
                    // this.$inertia.visit(this.$page.url)
                })
                .finally(() => {
                    this.dialog.loading = false;

                    // $('#' + this.resourceurl).modal('hide')
                });

            // }
        },

        back() {
            window.history.back();
        },
    },
    watch: {
        "form.lkp_poskod_id": function (q) {
            this.poskodDetail();
        },
        "form_cari.id": function (q) {
            this.profilDetail();
        },
    },
    mounted() {
        this.dialog.width = 900;
        // this.jenisAlamat();
    },
};
</script>

<style>
.w-select__menu {
    z-index: 999999;
}
</style>
